export default function serializeIntoHash(store, modelClass, snapshot, options = {
  includeId: true
}) {
  var serializer = store.serializerFor(modelClass.modelName);
  if (typeof serializer.serializeIntoHash === 'function') {
    var data = {};
    serializer.serializeIntoHash(data, modelClass, snapshot, options);
    return data;
  }
  return serializer.serialize(snapshot, options);
}